import React, { useEffect, useState } from "react";
import { Table, Image } from "react-bootstrap";
import moment from "moment";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";

export const OffersPageComponent = (props) => {
  let filteredData = props.data;

  if (props.search) {
    filteredData = filteredData.filter((item) => {
      return (
        (item &&
          item.restaurant_id &&
          item.restaurant_id.restaurant_name &&
          item.restaurant_id.restaurant_name
            .toLowerCase()
            .includes(props.search.toLowerCase())) ||
        item?.name?.toLowerCase().includes(props.search.toLowerCase())
      );
    });
  }

  if (props.sortBy === "Latest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(b.start_date) - new Date(a.start_date)
    );
  } else if (props.sortBy === "Oldest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(a.start_date) - new Date(b.start_date)
    );
  } else if (props.sortBy === "A-Z") {
    filteredData = filteredData?.sort((a, b) =>
      a.restaurant_id?.restaurant_name > b.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  } else if (props.sortBy === "Z-A") {
    filteredData = filteredData?.sort((a, b) =>
      b.restaurant_id?.restaurant_name > a.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  }

  if (props.filterBy) {
    if (props?.filterBy?.type)
      filteredData = filteredData?.filter((ele) => {
        if (props?.filterBy?.type == "online") return ele.isOnline;
        if (props?.filterBy?.type == "offline") return !ele.isOnline;
      });
    if (props?.filterBy?.disc)
      filteredData = filteredData?.filter((ele) => {
        if (props?.filterBy?.disc == "value") return !ele.isPercentage;
        if (props?.filterBy?.disc == "percentage") return ele.isPercentage;
      });
  }

  return (
    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
      <Table className="enMinWidth900">
        <thead>
          <tr className="super_admin_all_users_table_head">
            <th style={{ width: "20%" }} className="f12-700">
              Restaurant
              <br />
              Name
            </th>
            <th style={{ width: "25%" }} className="f12-700">
              My Offers/
              <br />
              Offer Type
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Offer
              <br />
              Category
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Start -<br />
              End Date
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Discount <br />
              Type
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Discount
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Fixed
              <br />
              Amount
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Offer Code
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Availed on
              <br />
              Services
            </th>
          </tr>
        </thead>
        {/* {props.allOffers.slice(start, end).map((offer, index) => ( */}
        {filteredData.map((offer, index) => (
          <tbody className="HideShowTable" key={index}>
            <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
              <td style={{ width: "20%" }}>
                <div className="d-flex flex-column align-items-start">
                  <div className="enImage45 ">
                    <Image
                      // src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                      src={
                        (offer &&
                          offer.restaurant_id &&
                          offer.restaurant_id.logo_url) ||
                        NOTAVAILABLEIMAGE
                      }
                      alt="Restaurant logo"
                      title="Restaurant logo"
                      fluid
                    />
                  </div>
                  <div className="f11-500 text-center mt-1">
                    {offer &&
                      offer.restaurant_id &&
                      offer.restaurant_id.restaurant_name}
                  </div>
                </div>
              </td>
              <td style={{ width: "25%" }}>
                <div className="d-flex align-items-center">
                  <div className="text-center d-flex flex-column align-items-center">
                    <div className="enIMG62">
                      {/* {offer.photos[0] ? ( */}
                      <Image
                        //src={require("../../../../../assets/images/UserManagement/offer.png")}
                        src={
                          (offer?.offer?.photos[0]) ||
                          NOTAVAILABLEIMAGE
                        }
                        alt="Offer img"
                        title="Offer img"
                        fluid
                      />
                      {/* ) : (
                        <Image
                          src={require("../../../../../assets/images/UserManagement/offer.png")}
                          alt="Offer img"
                          title="Offer img"
                          fluid
                        />
                      )} */}
                    </div>
                    <div className="enPendingLBL mt-2">
                      {offer?.offer?.isOnline ? "Online" : "Offline"}
                    </div>
                  </div>
                  <div className="pl-3">
                    {/* <div className="f12-500">{offer.name}</div> */}
                    {offer?.offer?.name}
                    <div className="f10-500 opacity5">{offer?.offer?.description}</div>
                  </div>
                </div>
              </td>
              <td style={{ width: "10%" }}>
                {offer?.offer?.settlementType === 'ADMIN' ? 'Amealio Offer' : 'Merchant Offer'}
              </td>
              <td style={{ width: "15%" }}>
                <div className="f14-400">
                  {moment(offer?.offer?.start_date).format("Do MMM  YY")}-
                </div>
                <div className="f14-400">to</div>
                <div className="f14-400 text-red">
                  {moment(offer?.offer?.end_date).format("Do MMM  YY")}
                </div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f14-500">
                  {" "}
                  {offer?.offer?.isPercentage ? "Percentage" : "Fixed"}
                </div>
              </td>
              <td style={{ width: "10%" }}>{offer?.discount?.amount}</td>
              <td style={{ width: "10%" }}>{offer?.offer?.discount}</td>
              <td style={{ width: "10%" }}>{offer?.offer?.coupon_code}</td>
              <td style={{ width: "10%" }}>
                {offer?.offer?.service_type?.join(',')}
              </td>
            </tr>
          </tbody>
        ))}

        {/* // ))} */}
      </Table>
    </div>
  );
};
